import { createAsyncThunk } from "@reduxjs/toolkit";

import { AsyncThunkOptionType } from "Reducers/types";
import { getEnvironmentVariablesRequest } from "Api/variables/environment/getEnvironmentVariables.request";
import type { Variable } from "Api/variables/environment/types";
type GetVariableThunkPropType = {
  environmentId: string;
  projectId: string;
  organizationId: string;
};

export const getVariables = createAsyncThunk<
  Variable[],
  GetVariableThunkPropType,
  AsyncThunkOptionType<{ error: string }>
>(
  "app/project/environment/variables",
  async ({ environmentId, projectId }, { rejectWithValue }) => {
    try {
      const variables = await getEnvironmentVariablesRequest({
        projectId,
        environmentId
      });

      return variables;
    } catch (error: any) {
      return rejectWithValue({ error: error.message });
    }
  }
);
